import * as yup from 'yup'

import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from 'reactstrap'
import { FaPencilAlt, FaSave, FaTrash } from 'react-icons/fa'
import React, { useState } from 'react'

import BuscadorTablas from 'components/Buscador/BuscadorTabla'
import PaginaPorDefecto from './Default'
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import { useCaracteristica } from 'hooks/useCaracteristicas'
import { useFormik } from 'formik'
import { useIndicador } from 'hooks/useIndicador'
import { useToggle } from 'hooks/useToggle'
import uuid from 'uuid/v4'

const initialValues = {
  nombre: '',
  descripcion: '',
  evidencias: '',
  caracteristica: '',
}

const indicadorSchema = yup.object().shape({
  nombre: yup.string().required('Este campo es requerido'),
  descripcion: yup.string().required('Este campo es requerido'),
  evidencias: yup.string().required('Este campo es requerido'),
  caracteristica: yup.string().required('Este campo es requerido'),
})

export default function Indicador() {
  const { open, onToggle } = useToggle()
  const [indicadorEdit, setIndicadorEdit] = useState(null)
  const [buscar, setBuscar] = useState('')
  const {
    obtenerIndicadores,
    handleEliminarIndicador,
    handleActualizarIndicador,
    handleCrearIndicador,
    handleBuscarIndicador,
  } = useIndicador(onToggle)
  const { obtenerCaracteristicas } = useCaracteristica(onToggle)
  const { data: caracteristicas } = obtenerCaracteristicas(buscar)
  const { data: indicadores } = obtenerIndicadores(buscar)

  const { handleChange, values, handleSubmit, errors } = useFormik({
    enableReinitialize: true,
    validationSchema: indicadorSchema,
    initialValues: {
      ...initialValues,
      ...indicadorEdit,
    },
    onSubmit: async (values, acciones) => {
      if (indicadorEdit) {
        handleActualizarIndicador({ values, acciones, id: indicadorEdit.id })
      } else {
        handleCrearIndicador(values, acciones)
      }
    },
  })

  const onClosedModal = () => {
    setIndicadorEdit(null)
  }

  return (
    <PaginaPorDefecto titulo='Indicador'>
      <Modal
        isOpen={open}
        toggle={onToggle}
        size='lg'
        unmountOnClose
        onClosed={onClosedModal}
      >
        <ModalHeader toggle={onToggle}>
          {indicadorEdit ? 'Editar' : 'Crear'} Indicador
        </ModalHeader>
        <ModalBody>
          <form className='form-horizontal col-xs-12' onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Nombre</Label>
              <Input
                type='text'
                name='nombre'
                value={values.nombre}
                onChange={handleChange}
                placeholder='Ingrese nombre'
                invalid={!!errors.nombre}
              />
              <div className='invalid-feedback'>{errors.nombre}</div>
            </FormGroup>

            <FormGroup>
              <Label>Descripción</Label>
              <Input
                type='textarea'
                name='descripcion'
                value={values.descripcion}
                onChange={handleChange}
                placeholder='Ingrese descripción'
                invalid={!!errors.descripcion}
              />
              <div className='invalid-feedback'>{errors.descripcion}</div>
            </FormGroup>

            <FormGroup>
              <Label>Evidencias</Label>
              <Input
                type='number'
                name='evidencias'
                value={values.evidencias}
                onChange={handleChange}
                placeholder='Ingrese evidencias'
                invalid={!!errors.evidencias}
              />
              <div className='invalid-feedback'>{errors.evidencias}</div>
            </FormGroup>

            <FormGroup>
              <Label>Característica</Label>
              <Input
                type='select'
                name='caracteristica'
                value={values.caracteristica}
                onChange={handleChange}
                placeholder='Ingrese caracteristica'
                invalid={!!errors.caracteristica}
              >
                <option value=''>Seleccione...</option>
                {caracteristicas?.results.map((caracteristica) => (
                  <option key={uuid()} value={caracteristica.id}>
                    {caracteristica.identificador}
                  </option>
                ))}
              </Input>
              <div className='invalid-feedback'>{errors.caracteristica}</div>
            </FormGroup>

            <div className='form-group'>
              <label
                className='col-md-12 control-label'
                htmlFor='singlebutton'
              ></label>
              <div className='col-md-12'>
                <Button className='mb-3' color='primary' type='submit'>
                  {indicadorEdit ? 'Editar' : 'Guardar'}
                </Button>
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>

      <TarjetaContenido
        titulo='Listar Indicador'
        component={
          <Button outline color='primary' onClick={onToggle}>
            <FaSave />
          </Button>
        }
      >
        <BuscadorTablas
          valor={buscar}
          onChange={setBuscar}
          onBuscar={handleBuscarIndicador}
        />
        {indicadores ? (
          <Table responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre</th>
                <th>Descripción</th>
                <th>Característica</th>
                <th>Evidencias</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {indicadores.results.map((indicador, index) => (
                <tr key={uuid()}>
                  <th scope='row'>{index + 1}</th>
                  <td>{indicador.nombre}</td>
                  <td>{indicador.descripcion}</td>
                  <td>{indicador.caracteristica__identificador}</td>
                  <td>{indicador.evidencias}</td>
                  <td className='d-flex'>
                    <Button
                      outline
                      color='primary'
                      size='sm'
                      className='mr-1'
                      onClick={() => {
                        setIndicadorEdit(indicador)
                        onToggle()
                      }}
                    >
                      <FaPencilAlt />
                    </Button>{' '}
                    <Button
                      outline
                      color='danger'
                      size='sm'
                      onClick={() => handleEliminarIndicador(indicador)}
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div>Loading...</div>
        )}
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
